import React, { useMemo } from 'react';
import StatsGroupApi from '../StatsGroupApi';
import StatsGroupSettings from '../StatsGroupSettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const StatsGroupActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = StatsGroupApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${ StatsGroupSettings.path }/${data.id}/view`}
                >
                    View
                </Link>

                <Link
                    path={`${ StatsGroupSettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link>

                <Link
                    confirm={ {
                        title: `Delete ${ data[StatsGroupSettings.primaryKey] }`,
                        message: "Are your sure you want to perform this action?"
                    } }
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default StatsGroupActions;
